<template>
  <div class="form">
    <!-- <el-dialog :title="title" :visible="visible" @close="onClose"> -->
    <el-form :ref="formName" :model="form" :rules="rules">
      <el-form-item
        v-for="(item, index) in normalizeScheme"
        :key="index"
        :label="item.label"
        :label-width="labelWidth"
        :prop="item.name"
      >
        <form-control-upload-image
          v-if="item.format === 'image'"
          v-model="form[item.name]"
          :type="'image'"
        />
        <el-input
          v-else-if="item.format === 'textarea'"
          v-model="form[item.name]"
          type="textarea"
          rows="3"
          class="mt10"
        />
        <el-switch
          v-else-if="item.format === 'boolean'"
          v-model="form[item.name]"
        />
        <el-input
          v-else-if="item.format === 'integer'"
          v-model="form[item.name]"
          type="number"
          class="mt10"
        />
        <el-select
          v-else-if="item.format === 'priducts'"
          v-model="form[item.name]"
          :multiple="false"
          :value-key="'id'"
          filterable
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="(option, optionName, index) in products"
            :key="index"
            :label="option.sku"
            :value="option.id"
            :readonly="true"
          />
        </el-select>
        <el-input v-else v-model="form[item.name]" type="text" class="mt10" />
      </el-form-item>
    </el-form>
    <!-- <span slot="footer" class="dialog-footer"> -->
    <div class="btns">
      <el-button @click="onClose">Отмена</el-button>
      <el-button type="primary" @click="onSubmit">{{
        existsData ? "Редактировать" : "Добавить"
      }}</el-button>
    </div>
    <!-- </span> -->
    <!-- </el-dialog> -->
  </div>
</template>

<script>
import { messages } from "@/utils/validate";
import FormControlUploadImage from "./FormControlUploadImage.vue";

export default {
  components: {
    FormControlUploadImage,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    scheme: {
      type: Array,
      required: true,
    },
    existsData: {
      type: Object,
      required: false,
    },
    title: {
      type: String,
      required: false,
      default: "Добавить элемент",
    },
    labelWidth: {
      type: String,
      required: false,
      default: "220px",
    },
  },
  data() {
    return {
      phones: [],
      formName: "dialog-form",
      form: {},
      rules: {},
      // products: [],
    };
  },
  watch: {
    existsData(val) {
      if (val) {
        this.fillForm();
      }
    },
  },
  computed: {
    normalizeScheme() {
      return this.scheme.filter((e) => !e.hidden);
    },
  },
  async created() {
    // const data = await getProducts();
    // this.products = data.products;
  },
  mounted() {
    this.addRules();
    this.resetFields();
    // this.fillForm();
  },
  methods: {
    fillForm() {
      if (this.existsData) {
        this.form = this.existsData.data;
      }
    },
    addRules() {
      this.scheme.forEach((e) => {
        this.rules[e.name] = this.getRulesItem(e);
      });
    },
    getRulesItem(item) {
      const rules = [];
      const maxLength = item.maxLength;
      const isRequired = item.required;

      if (isRequired) {
        rules.push({
          required: true,
          message: messages.required,
          trigger: ["blur", "change"],
        });
      }

      if (maxLength) {
        rules.push({
          max: maxLength,
          message: messages.maxLength + maxLength,
          trigger: ["blur", "change"],
        });
      }

      return rules;
    },
    resetFields() {
      const fields = {};

      this.scheme.forEach((e) => {
        fields[e.name] = e.default !== undefined ? e.default : null;
      });
      this.form = Object.assign({}, fields);
    },
    resetForm() {
      if (this.$refs[this.formName]) {
        this.$refs[this.formName].resetFields();
      }
    },
    onClose() {
      this.$emit("close");
      this.resetFields();
    },
    onSubmit() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          this.$emit("submit", {
            id: this.existsData ? this.existsData.id : null,
            data: Object.assign({}, this.form),
          });
          this.onClose();
        }
      });
    },
    onChange(id) {
      const phone = this.phones.find((e) => e.id === id);
      this.form.name = phone.name;
      this.form.phone_id = phone.id;
    },
  },
};
</script>

<style lang="scss">
.el-form-item.is-error .el-form-item:not(.is-error) .el-input__inner {
  border-color: #dcdfe6;
}
.form {
  border: 1px solid #dcdfe6;
  border-radius: 20px;
  padding: 10px 10px 10px 0;
}
.btns {
  display: flex;
  width: 100%;
  justify-content: center;
}
</style>
